import React from "react";
import PropTypes from "prop-types";

import {
    CREATOR_DASHBOARD_PHOTOS_REDIRECT,
    ICON_DASHBOARD,
    ICON_ACTIVITY,
    ICON_ROYALTIES,
    ICON_UPLOADS,
    ICON_CREATOR_HANDBOOK
} from "data/links";
import { PHOTO_ROYALTIES_FLAG } from "frontend/data/featureFlags";

import useFeatureFlag from "frontend/hooks/useFeatureFlag";

const CreatorProfileMenu = ({
    linkComponent,
    creatorUsername,
    isPhotoCreator,
    isIconCreator,
    isHeroSearchV2
}) => {
    const hasRoyaltiesAccess = useFeatureFlag(PHOTO_ROYALTIES_FLAG);

    const Link = linkComponent;
    const linkProps = {
        size: "md",
        styleType: "secondary",
        darkMode: !isHeroSearchV2,
        disableVisitedStyle: true
    };

    const sanitizedUsername = encodeURIComponent(creatorUsername);
    const photoDashboardHref = `${CREATOR_DASHBOARD_PHOTOS_REDIRECT.replace(
        ":username",
        sanitizedUsername
    )}`;
    const iconActivityHref = `${ICON_ACTIVITY.replace(
        ":username",
        sanitizedUsername
    )}`;
    const iconRoyaltiesHref = `${ICON_ROYALTIES.replace(
        ":username",
        sanitizedUsername
    )}`;

    return (
        <>
            {isIconCreator && <Link href={ICON_DASHBOARD}>Icon Dashboard</Link>}
            {hasRoyaltiesAccess && isPhotoCreator && (
                <Link href={photoDashboardHref} {...linkProps}>
                    Photo Dashboard
                </Link>
            )}
            {isIconCreator && (
                <>
                    <Link href={iconActivityHref} {...linkProps}>
                        Icon Activity
                    </Link>
                    <Link href={iconRoyaltiesHref} {...linkProps}>
                        Icon Royalties
                    </Link>
                    <Link href={ICON_UPLOADS} {...linkProps}>
                        Upload Icons
                    </Link>
                    <Link href={ICON_CREATOR_HANDBOOK} {...linkProps}>
                        Creator Handbook
                    </Link>
                </>
            )}
        </>
    );
};

CreatorProfileMenu.propTypes = {
    linkComponent: PropTypes.elementType.isRequired,
    creatorUsername: PropTypes.string.isRequired,
    isPhotoCreator: PropTypes.bool.isRequired,
    isIconCreator: PropTypes.bool.isRequired
};

export default CreatorProfileMenu;
